import { GetPositionQuoteResponseSchema, GetPositionQuoteUrlSchema } from '@schuettflix/interfaces';
import { z } from 'zod';
import { useHttpClientContext } from '@/shared/context/HttpClientContext.tsx';

export const useGetPositionQuoteByPositionProductId = () => {
    const { positionClient } = useHttpClientContext();

    return {
        getPositionQuoteByPositionProductId: async ({
            positionProductId,
        }: {
            positionProductId: z.infer<typeof GetPositionQuoteUrlSchema>['positionProductId'];
        }) => {
            return positionClient
                .get<z.infer<typeof GetPositionQuoteResponseSchema>>(`/v1/position-quotes/${positionProductId}`)
                .then(res => GetPositionQuoteResponseSchema.parse(res.data));
        },
    };
};
